
import { Grid, Container,} from '@mui/material';
// import { useTheme } from '@mui/material/styles';

import useSettings from '../../hooks/useSettings';

import Page from '../../components/Page';

import AllBlogs from '../../sections/tables/AllBlogs';



// ----------------------------------------------------------------------

export default function Blog() {
  const { themeStretch } = useSettings();
//   const theme = useTheme();





  return (
    <Page title="Dashboard Blog">
      <Container maxWidth={themeStretch ? false : 'xl'}>
    
         
       
        <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <AllBlogs />
          </Grid>
          </Grid>
      </Container>
    </Page>
  );
}
